export default "__VITE_PUBLIC_ASSET__0ed79f5b__"